module.exports = __webpack_public_path__ + "img/contractor.302d28d3.svg";